import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconYoutubeDark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2036 3.64502C10.6487 3.64747 11.7622 3.65824 12.9454 3.70563L13.3649 3.72392C14.5562 3.78032 15.7464 3.87667 16.3367 4.04127C17.1242 4.26248 17.7431 4.90794 17.9522 5.72612C18.2853 7.02536 18.327 9.56119 18.3322 10.1749L18.3329 10.302V10.3109C18.3329 10.3109 18.3329 10.314 18.3329 10.3199L18.3322 10.4471C18.327 11.0608 18.2853 13.5966 17.9522 14.8959C17.7402 15.717 17.1212 16.3625 16.3367 16.5807C15.7464 16.7453 14.5562 16.8416 13.3649 16.898L12.9454 16.9163C11.7622 16.9637 10.6487 16.9744 10.2036 16.9769L10.0082 16.9776H9.99957C9.99957 16.9776 9.99666 16.9776 9.99091 16.9776L9.79574 16.9769C8.85374 16.9718 4.91509 16.9292 3.66242 16.5807C2.87499 16.3594 2.25609 15.714 2.04688 14.8959C1.71383 13.5966 1.67219 11.0608 1.66699 10.4471V10.1749C1.67219 9.56119 1.71383 7.02536 2.04688 5.72612C2.25899 4.9049 2.87789 4.25945 3.66242 4.04127C4.91509 3.69271 8.85374 3.6502 9.79574 3.64502H10.2036ZM8.33292 7.3943V13.2276L13.3329 10.3109L8.33292 7.3943Z",
		fill: "#03314B"
	})
});
export default SvgIconYoutubeDark;
